/**
 * List of global variables used on our project.
 */
import { environment } from '../environments/environment';

import { checkSlash } from '@shared/utils/path-utils';

/**
 * Default chunk size for getting max number of items
 */
export const MAX_PAGE_SIZE = 10000;
export const SITE_BATCH_SIZE = 200;

/*
 * Different token types
 */
/**
 * Usage ways:
 *  - As the `Authorization` header value.
 *    Put it there and {@link SessionInterceptor} will replace it with current the personal token.
 *  - As a key for Local Storage to save the token between pare refreshing
 */
export const SITE_TOKEN = 'siteToken';
export const LOGO_URL = 'logoUrl';

export const COMPANY_ID = 'companyId';
export const SITE_ID = 'siteId';
export const EMPLOYEE_ID = 'EmployeeId';
export const ROLE_ID = 'roleId';
export const EVENT_ID = 'eventId';
export const MAX_QRY = 999999;

export const BASE_URI = checkSlash(environment.baseURI);
export const DM_BACKEND_URI = checkSlash(environment.dmBackendURI);
export const XPRT_BACKEND_URI = checkSlash(environment.xprtBackendURI);
export const XEA_BACKEND_URI = checkSlash(environment.xeaBackendURI);
export const XVI_BACKEND_URI = checkSlash(environment.xviBackendURI);

/**
 * error page title
 */

export enum TIME_FORMATS {
  MMDDYYYY = 'MM/DD/YYYY',
  YYYYMMDD = 'YYYY-MM-DD',
}

/**
 * Usage ways:
 *  - As the lang for all application.
 */
export const USER_LOCALE_FIELD = 'userLocale';
export const DEFAULT_LOCALE = 'en-US';

/**
 * User-defined i18n field names
 */
export const NESTED_FIELD_SEPARATOR = '.';
export const ARRAY_OF_OBJECT_PATH_SEPARATOR = '[]';
export const TRANSLATION_OBJECT_FIELD = 'i18n';
export const ORIGINAL_VALUE_FIELD = 'original';
export const MAX_CLONE_DEPTH = 9;

export const HTTP_SUCCESS_STATUS_LOWER_BOUND = 200;
export const HTTP_SUCCESS_STATUS_UPPER_BOUND = 300;
